@import "../../../../../shared/styles/base";

.c-search-input {
  &--top-bar {
    margin: 0;
    width: 18rem;
  }
}
